import { ref, computed } from 'vue'
import { formatMobileForBackend } from '@/utils/formatters'

export function useMobileValidation() {
  const mobileNo = ref<string>('')
  const mobileError = ref<string | undefined>(undefined)

  const formattedMobileNo = computed(() => {
    if (!mobileNo.value) return ''
    return formatMobileForBackend(mobileNo.value, '+94')
  })

  const formattedMobileDisplay = computed(() => {
    if (!mobileNo.value) return '+94 7XX XXX XXX'
    const cleaned = mobileNo.value.replace(/\D/g, '')
    if (cleaned.length === 0) return '+94 7XX XXX XXX'
    const masked = cleaned.slice(0, 2) + 'X'.repeat(Math.max(0, cleaned.length - 2))
    const formatted = masked.match(/.{1,3}/g)?.join(' ') || masked
    return `+94 ${formatted}`
  })

  const isValid = computed(() => {
    const cleaned = mobileNo.value.replace(/\D/g, '')
    return cleaned.length >= 9 && cleaned.length <= 10
  })

  const handleMobileInputUpdate = (value: string | number): void => {
    mobileNo.value = String(value).replace(/\D/g, '')
    if (mobileError.value) {
      mobileError.value = undefined
    }
  }

  const validateMobile = (): boolean => {
    if (!mobileNo.value) {
      mobileError.value = 'Mobile number is required'
      return false
    }
    const cleaned = mobileNo.value.replace(/\D/g, '')
    if (cleaned.length < 9) {
      mobileError.value = 'Mobile number must be at least 9 digits'
      return false
    }
    if (cleaned.length > 10) {
      mobileError.value = 'Mobile number must be at most 10 digits'
      return false
    }
    mobileError.value = undefined
    return true
  }

  const clearError = (): void => {
    mobileError.value = undefined
  }

  const setError = (error: string): void => {
    mobileError.value = error
  }

  return {
    mobileNo,
    mobileError,
    formattedMobileNo,
    formattedMobileDisplay,
    isValid,
    handleMobileInputUpdate,
    validateMobile,
    clearError,
    setError,
  }
}
